import React, { useEffect, useRef, useState } from "react"

export default function GlobalPaging({ OnPageChange, pagingData, text = "Entries", children, loading = false }) {
    const [pending, setPending] = useState(null)
    const lockRef = useRef(false)
    const wasLoading = useRef(loading)

    // server naya pageNumber confirm kare -> dobara sync
    useEffect(() => {
        setPending(null)
        lockRef.current = false
    }, [pagingData?.pageNumber])

    // loading true->false -> lock chhodo (safety)
    useEffect(() => {
        if (wasLoading.current && !loading) {
            setPending(null)
            lockRef.current = false
        }
        wasLoading.current = loading
    }, [loading])

    if (!pagingData) {
        return <div>{children}</div>
    }

    const pageCount = Number(pagingData.pageCount) || 0
    const serverPage = Number(pagingData.pageNumber) || 0
    const current = pending ?? serverPage
    const isFirst = current <= 1 || pageCount === 0
    const isLast = current >= pageCount || pageCount === 0
    const busy = loading || pending !== null
    const pendingDir = pending == null ? null : pending > serverPage ? "next" : "prev"

    const go = (target) => {
        if (lockRef.current || loading) return        // request chal rahi hai -> ignore (desync rokta hai)
        if (target < 1 || target > pageCount) return
        lockRef.current = true
        setPending(target)
        OnPageChange(target)                          // parent ko seedha number
    }

    const Spinner = () => (
        <svg className="h-3.5 w-3.5 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-90" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
        </svg>
    )

    const baseBtn =
        "flex h-8 items-center justify-center px-3 text-sm font-medium text-white transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400/60 disabled:opacity-70"

    return (
        <div>
            {children}

            <div className="mt-4 w-full">
                <div className="flex flex-col items-center gap-2 p-2 sm:flex-row sm:justify-between">

                    {/* summary */}
                    <span aria-live="polite" className="text-sm text-gray-400">
                        Showing <span className="font-semibold text-gray-600">{pagingData.firstItemOnPage}</span>
                        -<span className="font-semibold text-gray-600">{pagingData.lastItemOnPage}</span> of{" "}
                        <span className="font-semibold text-gray-600">{pagingData.totalItemCount}</span> {text}
                        <span className="ml-1.5 inline-flex items-center whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500">
                            {current}/{pageCount}
                        </span>
                    </span>

                    {/* controls */}
                    <div className="inline-flex overflow-hidden rounded shadow-sm">
                        <button
                            type="button"
                            aria-label="Previous page"
                            onClick={() => go(current - 1)}
                            disabled={busy || isFirst}
                            className={`${baseBtn} rounded-s ${isFirst ? "cursor-not-allowed bg-brand-300" : "bg-brand-400 hover:bg-brand-500 active:scale-95"}`}
                        >
                            {busy && pendingDir === "prev" ? <Spinner /> : (
                                <svg className="h-3.5 w-3.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
                                </svg>
                            )}
                        </button>

                        <button
                            type="button"
                            aria-label="Next page"
                            onClick={() => go(current + 1)}
                            disabled={busy || isLast}
                            className={`${baseBtn} rounded-e border-s border-brand-700 ${isLast ? "cursor-not-allowed bg-brand-300" : "bg-brand-400 hover:bg-brand-500 active:scale-95"}`}
                        >
                            {busy && pendingDir === "next" ? <Spinner /> : (
                                <svg className="h-3.5 w-3.5 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}